import axios, { formDataRequest } from './axios'

export const getContractorSessions = (params = {}) =>
	axios.get('/contractor_session', {
		params: {
			contractor_name: params.contractor_name,
			client_id: params.client_id,
			start_date: params.start_date,
			end_date: params.end_date
		}
	})

export const createContractorSession = data => axios.post('/contractor_session', data)
